module.exports = __webpack_public_path__ + "static/media/care_hawaii3.8745afa8.JPG";